<template>
  <div class="w-full height-100">
    <el-dialog :visible.sync="uploaderPopup" width="45%" center>
      <template slot="title"
        ><h3 class="fsize16 Add mb-0 Products text-white">Upload</h3></template
      >

      <div class="p-3">
        <el-upload
          class="upload-demo"
          drag
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-success="handleUploadSuccess"
          :before-upload="beforeUpload"
          :accept="['image/jpg', 'image/jpeg', 'image/png']"
          multiple
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Drop file here or <em>click to upload</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            jpg/png files with a size less than 500kb
          </div>
        </el-upload>

        <div class="grid grid-cols-3 items-center gap-4 mt-4">
          <div
            class="img_wrap"
            v-for="(item, index) in Fetchedmedias"
            :key="index"
            @click="primaryclick(item)"
            v-show="item.type !== 'video'"
          >
            <div>
              <div>
                <img
                  :src="url1 + item.link"
                  alt="image"
                  class="w-full object-cover rounded-4px h-72px cursor-pointer"
                />
              </div>
            </div>

            <div class="previewselect" v-if="PrimaryLogoMedia._id == item._id">
              <feather-icon
                icon="CheckIcon"
                svgClasses="w-8 h-8"
                class="text-success font-semibold"
              />
            </div>
          </div>
        </div>
        <div class="w-full flex justify-end mt-6">
          <el-pagination
            background
            layout="prev,pager,next"
            :total="100"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="isShowAddMenu"
      :before-close="handleclosesubmenu"
      :direction="direction"
      width="30%"
    >
      <template slot="title"
        ><h3 class="fsize16 Add Products text-white">Add Menu</h3></template
      >
      <div>
        <div>
          <div>
            <p class="text-lg font-semibold text-4f4f4f mb-0">Image</p>
            <!-- <el-upload
              v-if="datavalue.length == 0 && submenuimage == ''"
              class="upload-demo mt-1 category-uploader"
              drag
              accept="image/*"
              :before-upload="multipleimages"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Drop file here or <em>click to upload</em>
              </div>
              
            </el-upload> -->
            <div class="relative">
              <el-input
                placeholder=""
                v-model="uploadImage"
                class="w-full mt-2"
              ></el-input>
              <div class="absolute topright181011">
                <feather-icon
                  icon="UploadIcon"
                  svgClasses="w-4 h-4"
                  class="cursor-pointer"
                  @click="uploaderPopup = true"
                />
              </div>
            </div>
          </div>
          <div class="mt-6" v-if="submenuimage == ''">
            <div
              v-for="(item, index) in renderedmultipleImage"
              class="relative"
              :key="index"
            >
              <img :src="item" class="object-cover imgpre" />

              <div
                class="absolute flex justify-center items-center w-6 h-6 top-right-2px bg-white rounded-full p-1"
              >
                <feather-icon
                  icon="XIcon"
                  svgClasses="w-3 h-3"
                  class="cursor-pointer"
                  @click="
                    () => {
                      datavalue.splice(index, 1);
                      renderedmultipleImage.splice(index, 1);
                    }
                  "
                />
              </div>
            </div>
          </div>
          <div class="mt-6" v-if="submenuimage != ''">
            <!-- <div class="relative">
              <img
                :src="
                  submenuimage
                    ? imageURL + submenuimage
                    : imageURL + 'Admin/Assets/DefaultUpload.png'
                "
                class="object-cover imgpre"
                alt="sdfsdfljsdklfjhjkh"
              />

              <div
                class="absolute flex justify-center items-center w-6 h-6 top-right-2px bg-white rounded-full p-1"
              >
                <feather-icon
                  icon="XIcon"
                  svgClasses="w-3 h-3"
                  class="cursor-pointer"
                  @click="submenuimage = ''"
                />
              </div>
            </div> -->
          </div>
          <div class="mt-6">
            <p class="text-lg font-semibold text-4f4f4f mb-0">Menu Name</p>
            <el-input
              placeholder="Enter..."
              v-model="menuName"
              class="w-full mt-2"
              @change="inputMenuName()"
            ></el-input>
            <p class="text-danger mt-1" v-if="isShowErrorMenuName">
              This field is required
            </p>
          </div>
          <div class="mt-6">
            <p class="text-lg font-semibold text-4f4f4f mb-0">Add Position</p>
            <el-input
              placeholder="Enter..."
              v-model="position"
              class="w-full mt-2"
            ></el-input>
            <!-- <p class="text-4f4f4f mb-0 text-base" v-if="isShowPositionMsg">
              This position already exists
            </p> -->
          </div>
          <div class="mt-6">
            <p class="text-lg font-semibold text-4f4f4f mb-0">
              Select Parent Menu
            </p>
            <el-select
              multiple
              filterable
              allow-create
              default-first-option
              v-model="selectedMenu"
              placeholder="Select"
              class="w-full mt-1"
            >
              <el-option
                v-for="item in this.menuData"
                :key="item"
                :label="item.menuName"
                :value="item._id"
              >
              </el-option>
            </el-select>
          </div>

          <div class="mt-6">
            <p class="text-lg font-semibold text-4f4f4f mb-0">
              Select Menu Type
            </p>
            <el-select
              filterable
              default-first-option
              v-model="selectedMenuType"
              placeholder="Select"
              class="w-full mt-1"
              @change="selectedMenuTpyeValue(selectedMenuType)"
            >
              <el-option
                v-for="item in menuType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <p class="text-danger mt-1" v-if="isShowErrorMenuType">
              This field is required
            </p>
          </div>

          <!-- <div class="mt-6">
            <p class="text-lg font-semibold text-4f4f4f mb-0">Sub-Menu</p>
            <el-select
              multiple
              filterable
              allow-create
              default-first-option
              v-model="menu"
              placeholder="Select"
              class="w-full mt-1"
            >
              <el-option
                v-for="item in menuData"
                :key="item.menuName"
                :label="item.menuName"
                :value="item.menuName"
              >
              </el-option>
            </el-select>
          </div> -->
          <div class="mt-6" v-if="ispage">
            <p class="text-lg font-semibold text-4f4f4f mb-0">Pages</p>
            <el-select
              filterable
              v-model="page"
              placeholder="Select"
              class="w-full mt-1"
              @change="addPages"
            >
              <el-option
                v-for="item in pages"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
            <p class="text-danger mt-1" v-if="isShowErrorMenuPage">
              This field is required
            </p>
          </div>
          <div class="mt-6" v-if="isElement">
            <p class="text-lg font-semibold text-4f4f4f mb-0">
              Select Component
            </p>
            <el-select
              filterable
              v-model="selectedComponent"
              placeholder="Select"
              class="w-full mt-1"
            >
              <el-option
                v-for="item in components"
                :key="item"
                :label="item.elementName"
                :value="item.componentId"
              >
              </el-option>
            </el-select>
            <p class="text-danger mt-1" v-if="isShowErrorComponent">
              This field is required
            </p>
          </div>

          <div class="mt-6" v-if="isCategory">
            <p class="text-lg font-semibold text-4f4f4f mb-0">Category</p>
            <el-select
              filterable
              v-model="selectedCategory"
              placeholder="Select"
              class="w-full mt-1"
              @change="inputCategoryData"
            >
              <el-option
                v-for="item in detailedCategory"
                :key="item"
                :label="item.categoryName"
                :value="item._id"
              >
              </el-option>
            </el-select>
            <p class="text-danger mt-1" v-if="isShowErrorCategory">
              This field is required
            </p>
          </div>
          <div class="mt-6" v-if="isURL">
            <p class="text-lg font-semibold text-4f4f4f mb-0">URL</p>
            <el-input
              placeholder="Enter..."
              v-model="menuURL"
              class="w-full mt-2"
              @change="inputMenuURLData"
            ></el-input>
            <p class="text-danger mt-1" v-if="isShowErrorUrl">
              This field is required
            </p>
          </div>
          <div class="mt-6" v-if="isProduct">
            <p class="text-lg font-semibold text-4f4f4f mb-0">Product</p>
            <el-select
              filterable
              v-model="selectedProduct"
              placeholder="Select"
              class="w-full mt-1"
              @change="inputProductData"
            >
              <el-option
                v-for="item in productDetails"
                :key="item"
                :label="item.productName"
                :value="item._id"
              >
              </el-option>
            </el-select>
            <p class="text-danger mt-1" v-if="isShowErrorProduct">
              This field is required
            </p>
          </div>
        </div>

        <div class="flex justify-center mt-10" v-if="updatesubment">
          <vs-button
            @click="updateSubMenu"
            class="font-semibold py-4 fsize14 px-16 sm-fsize14"
          >
            Update
          </vs-button>
        </div>
        <div class="flex justify-center mt-10" v-else>
          <vs-button
            @click="addMenu()"
            class="font-semibold py-4 fsize14 px-16 sm-fsize14"
            :disable="!validateMenu && !validateMenuType"
          >
            Submit
          </vs-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="isShowAddMainMenu"
      :before-close="handleclose"
      :direction="direction"
      width="30%"
    >
      <template slot="title"
        ><h3 class="fsize16 Add Products text-white">Add Menu</h3></template
      >
      <div>
        <div>
          <div>
            <p class="text-lg font-semibold text-4f4f4f mb-0">Image</p>
            <div class="relative">
              <el-input
                placeholder=""
                v-model="uploadImage"
                class="w-full mt-2"
              ></el-input>
              <div class="absolute topright18102">
                <feather-icon
                  icon="UploadIcon"
                  svgClasses="w-4 h-4"
                  class="cursor-pointer"
                  @click="uploaderPopup = true"
                />
              </div>
            </div>
          </div>

          <div class="mt-6" v-if="mainmenuimage == ''">
            <div
              v-for="(item, index) in renderedmultipleImage"
              class="relative"
              :key="index"
            >
              <img :src="item" class="object-cover imgpre" />

              <div
                class="absolute flex justify-center items-center w-6 h-6 top-right-2px bg-white rounded-full p-1"
              >
                <feather-icon
                  icon="XIcon"
                  svgClasses="w-3 h-3"
                  class="cursor-pointer"
                  @click="
                    () => {
                      datavalue.splice(index, 1);
                      renderedmultipleImage.splice(index, 1);
                    }
                  "
                />
              </div>
            </div>
          </div>
          <div class="mt-6" v-if="mainmenuimage != ''">
            <!-- <div>
              <img
                :src="
                  mainmenuimage
                    ? imageURL + mainmenuimage
                    : imageURL + 'Admin/Assets/DefaultUpload.png'
                "
                class="object-cover imgpre"
              />

              <div
                class="absolute flex justify-center items-center w-6 h-6 top-right-2px bg-white rounded-full p-1"
              >
                <feather-icon
                  icon="XIcon"
                  svgClasses="w-3 h-3"
                  class="cursor-pointer"
                  @click="mainmenuimage = ''"
                />
              </div>
            </div> -->
          </div>
          <div class="mt-6">
            <p class="text-lg font-semibold text-4f4f4f mb-0">Menu Name</p>
            <el-input
              placeholder="Enter..."
              v-model="menuName"
              class="w-full mt-2"
            ></el-input>
          </div>
          <div class="mt-6">
            <p class="text-lg font-semibold text-4f4f4f mb-0">Add Position</p>
            <el-input
              placeholder="Enter..."
              v-model="position"
              class="w-full mt-2"
            ></el-input>
            <!-- <p class="text-4f4f4f mb-0 text-base" v-if="isShowPositionMsg">
              This position already exists
            </p> -->
          </div>
          <!-- <div class="mt-6">
            <p class="text-lg font-semibold text-4f4f4f mb-0">Sub-Menu</p>
            <el-select
              multiple
              filterable
              allow-create
              default-first-option
              v-model="menu"
              placeholder="Select"
              class="w-full mt-1"
            >
              <el-option
                v-for="item in this.menuData"
                :key="item"
                :label="item.menuName"
                :value="item._id"
              >
              </el-option>
            </el-select>
          </div> -->
          <div class="mt-6">
            <p class="text-lg font-semibold text-4f4f4f mb-0">Parent Menu</p>
            <el-select
              multiple
              filterable
              allow-create
              default-first-option
              v-model="menuParent"
              placeholder="Select"
              class="w-full mt-1"
            >
              <el-option
                v-for="item in this.menuData"
                :key="item"
                :label="item.menuName"
                :value="item._id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="mt-6">
            <p class="text-lg font-semibold text-4f4f4f mb-0">
              Select Menu Type
            </p>
            <el-select
              filterable
              default-first-option
              v-model="selectedMenuType"
              placeholder="Select"
              class="w-full mt-1"
              @change="selectedMenuTpyeValue(selectedMenuType)"
            >
              <el-option
                v-for="item in menuType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="mt-6" v-if="ispageEdit">
            <p class="text-lg font-semibold text-4f4f4f mb-0">Pages</p>
            <el-select
              filterable
              v-model="page"
              placeholder="Select"
              class="w-full mt-1"
              @change="addPages"
            >
              <el-option
                v-for="item in pages"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </div>

          <div class="mt-6" v-if="isCategoryEdit">
            <p class="text-lg font-semibold text-4f4f4f mb-0">Category</p>
            <el-select
              filterable
              v-model="selectedCategory"
              placeholder="Select"
              class="w-full mt-1"
            >
              <el-option
                v-for="item in detailedCategory"
                :key="item"
                :label="item.categoryName"
                :value="item._id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="mt-6" v-if="isURLEdit">
            <p class="text-lg font-semibold text-4f4f4f mb-0">URL</p>
            <el-input
              placeholder="Enter..."
              v-model="menuURL"
              class="w-full mt-2"
            ></el-input>
          </div>
          <div class="mt-6" v-if="isProductEdit">
            <p class="text-lg font-semibold text-4f4f4f mb-0">Product</p>
            <el-select
              filterable
              v-model="selectedProduct"
              placeholder="Select"
              class="w-full mt-1"
            >
              <el-option
                v-for="item in productDetails"
                :key="item"
                :label="item.productName"
                :value="item._id"
              >
              </el-option>
            </el-select>
          </div>
          <!-- <div class="mt-6">
            <p class="text-lg font-semibold text-4f4f4f mb-0">Pages</p>
            <el-select
              multiple
              filterable
              v-model="page"
              placeholder="Select"
              class="w-full mt-1"
              @change="addPages"
            >
              <el-option
                v-for="item in pages"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </div> -->
        </div>
        <div class="flex justify-center mt-10 w-full" v-if="updatemenu">
          <vs-button
            @click="UpdateMainMenu()"
            class="font-semibold py-4 w-full fsize14 px-16 sm-fsize14"
            :disabled="!validateMenu && validateMenuType"
          >
            Update
          </vs-button>
        </div>
        <div class="flex justify-center w-full mt-10" v-else>
          <vs-button
            @click="addMainMenu()"
            class="font-semibold w-full py-4 fsize14 px-16 sm-fsize14"
            :disabled="!validateMenu && validateMenuType"
          >
            Submit
          </vs-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      :direction="direction"
      width="30%"
    >
      <template slot="title"
        ><h3 class="fsize16 Add Products text-white">
          Select Menu Heirarchy
        </h3></template
      >
      <div>
        <el-radio v-model="radio" label="1">Two heirarchy</el-radio>
        <el-radio v-model="radio" label="2">Three heirarchy</el-radio>
      </div>
    </el-dialog>

    <div class="seth-set bg-primary">
      <div
        src="@/assets/images/banh.png"
        class="bg-primary ban-marcom100 w-full"
        alt="banh"
      ></div>
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div class="">
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Website Menu
          </h2>
        </div>
      </div>
    </div>

    <div class="fixed-top bg-white p-6">
      <div class="flex justify-end items-center gap-4">
        <!-- <feather-icon
          icon="SettingsIcon"
          @click="dialogVisible = true"
          class="bg-gray flex items-center cursor-pointer p-2 rounded-lg text-white"
          svgClasses="w-6 h-6"
        /> -->
        <vs-button
          @click="openAddMenuForm"
          class="font-semibold rounded-lg lg:py-3 fsize14 md:py-3 py-2 px-10 sm-fsize14"
        >
          Add Menu
        </vs-button>
        <!-- <vs-button
          @click="openAddMainMenuForm"
          class="font-semibold lg:py-3 fsize14 md:py-3 py-2 px-10 sm-fsize14"
        >
          Add Menu
        </vs-button> -->
      </div>

      <div>
        <el-table
          v-if="menuData.length"
          empty-text="no  data"
          :data="menuData"
          border
          style="width: 100%"
          height="490"
          class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
          header-row-class-name="thead-light table-th-colorpd"
        >
          <el-table-column
            :index="indexmethod"
            type="index"
            label="Sr.no"
            width="80"
          ></el-table-column>
          <el-table-column prop="position" label="Position" min-width="50px">
            <template v-slot="{ row }">
              <P class="text-gray">{{ row.position }}</P>
            </template>
          </el-table-column>
          <el-table-column prop="menuName" label="Menu Name" min-width="200px">
            <template v-slot="{ row }">
              <P class="text-gray">{{ row.menuName }}</P>
            </template>
          </el-table-column>

          <!-- <el-table-column prop="pages" label="Pages" min-width="200px">
            <template v-slot="{ row }">
              <div class="flex gap-2 flex-wrap">
                <el-tag
                  v-for="(item, index) in row.pageData"
                  :key="index"
                  class="text-gray rounded-full"
                  type="success"
                  >{{ item.name }}</el-tag
                >
              </div>
            </template>
          </el-table-column> -->

          <el-table-column prop="subMenu" label="Sub-Menu" min-width="200px">
            <template v-slot="{ row }">
              <div class="flex gap-2 flex-wrap">
                <el-tag
                  v-for="(item, index) in row.subMenu"
                  :key="index"
                  class="text-gray rounded-full"
                  type="success"
                  >{{ item.menuName }}</el-tag
                >
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="parentMenu"
            label="Parent Menu"
            min-width="150px"
          >
            <template v-slot="{ row }">
              <div class="flex gap-2 flex-wrap">
                <el-tag
                  v-for="(item, index) in row.ParentMenu"
                  :key="index"
                  class="text-gray rounded-full"
                  type="success"
                  >{{ item.menuName }}</el-tag
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="menutype"
            label="Redirection Type"
            min-width="200px"
          >
            <template v-slot="{ row }">
              <P class="text-gray">{{ row.menutype }}</P>
            </template>
          </el-table-column>

          <el-table-column
            prop="menuImage"
            label="Menu Image"
            min-width="150px"
          >
            <template v-slot="{ row }">
              <div v-if="row.menuImage.length > 0">
                <img
                  :src="
                    row.menuImage
                      ? imageURL + row.menuImage
                      : imageURL + 'Admin/Assets/DefaultUpload.png'
                  "
                  alt="image"
                  class="w-16 h-12"
                />
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="city" label="Actions" min-width="90px">
            <template v-slot="{ row }">
              <div class="flex gap-1 items-center justify-evenly">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-4 h-4"
                  class="cursor-pointer"
                  @click="handleEdit(row)"
                />
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-4 h-4 text-danger"
                  class="cursor-pointer"
                  @click="handledelete(row)"
                />
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="w-full flex justify-between mt-6">
          <el-pagination
            background
            @current-change="
              (value) => {
                currentPage = value;
                getMenu();
              }
            "
            layout="prev,pager,next"
            :per-size="10"
            :total="pageCount"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import axios from "axios";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      selectedItem: {},
      pageCount: 0,
      currentPage: 1,
      isShowAddMenu: false,
      isShowAddMainMenu: false,
      dialogVisible: false,
      radio: "1",
      direction: "rtl",
      menu: [],
      menuParent: [],
      tagName: null,
      menuName: "",
      position: "",
      datavalue: [],
      renderedmultipleImage: [],
      page: [],
      pageData: [],
      tasklist: "",
      pages: "",
      updatemenu: false,
      updatesubment: false,
      menuid: "",
      submenuimage: "",
      mainmenuimage: "",
      selectedComponent: "",
      submenuData: [],
      checkPosition: false,
      isShowPositionMsg: false,
      uploadImage: "",
      uploaderPopup: false,
      Fetchedmedias: [],
      url1: this.$imageURL,
      PrimaryLogoMedia: {},
      components: [],
      selectedMenuType: "",
      menuType: [
        {
          label: "Page",
          value: "page",
        },
        {
          label: "Product",
          value: "product",
        },
        {
          label: "Category",
          value: "category",
        },
        {
          label: "URL",
          value: "url",
        },
        {
          label: "Element",
          value: "element",
        },
      ],
      ispage: false,
      isProduct: false,
      isCategory: false,
      isURL: false,
      isElement: false,
      ispageEdit: false,
      isProductEdit: false,
      isCategoryEdit: false,
      isURLEdit: false,
      isElementEdit: false,
      selectedCategory: "",
      selectedProduct: "",
      menuURL: "",
      selectedMenu: [],
      isShowErrorMenuType: false,
      isShowErrorMenuName: false,
      isShowErrorMenuPage: false,
      isShowErrorComponent: false,
      isShowErrorProduct: false,
      isShowErrorCategory: false,
      isShowErrorUrl: false,
    };
  },

  methods: {
    async Fetchmedia() {
      let mediaData = await axios.post(
        process.env.VUE_APP_SVG_DATAENTRY + "/Media" + "/Fetch",
        {},
        {
          headers: {
            "community-name": process.env.VUE_APP_COMMUNITY_NAME,
          },
        }
      );
      this.Fetchedmedias = mediaData.data;
    },
    async preloadData() {
      await this.$store.dispatch("EcomCategory/getDetailedCategory");
      await this.$store.dispatch("EcomProduct/getAllProduct");
    },

    selectedMenuTpyeValue(data) {
      if (this.selectedMenuType == "") {
        this.isShowErrorMenuType = true;
      } else {
        this.isShowErrorMenuType = false;
      }
      this.page = [];
      this.selectedCategory = "";
      this.menuURL = "";
      this.selectedProduct = "";
      if (data === "page") {
        this.ispage = true;
        this.isProduct = false;
        this.isCategory = false;
        this.isURL = false;
        this.isElement = false;
        this.ispageEdit = true;
        this.isProductEdit = false;
        this.isCategoryEdit = false;
        this.isURLEdit = false;
        this.isElementEdit = false;
      }
      if (data === "product") {
        this.ispage = false;
        this.isProduct = true;
        this.isCategory = false;
        this.isURL = false;
        this.isElement = false;
        this.ispageEdit = false;
        this.isProductEdit = true;
        this.isCategoryEdit = false;
        this.isURLEdit = false;
        this.isElementEdit = false;
      }
      if (data === "category") {
        this.ispage = false;
        this.isProduct = false;
        this.isCategory = true;
        this.isURL = false;
        this.isElement = false;
        this.ispageEdit = false;
        this.isProductEdit = false;
        this.isCategoryEdit = true;
        this.isURLEdit = false;
        this.isElementEdit = false;
      }
      if (data === "url") {
        this.ispage = false;
        this.isProduct = false;
        this.isCategory = false;
        this.isURL = true;
        this.isElement = false;
        this.ispageEdit = false;
        this.isProductEdit = false;
        this.isCategoryEdit = false;
        this.isURLEdit = true;
        this.isElementEdit = false;
      }
      if (data === "element") {
        this.ispage = true;
        this.isProduct = false;
        this.isCategory = false;
        this.isURL = false;
        this.isElement = false;
        this.ispageEdit = true;
        this.isProductEdit = false;
        this.isCategoryEdit = false;
        this.isURLEdit = false;
        this.isElementEdit = false;
      }
    },
    indexmethod(index) {
      if (this.currentPage > 1) {
        let value = (this.currentPage - 1) * 10;
        return index + value + 1;
      } else {
        return index + 1;
      }
    },
    async handleUploadSuccess(name) {
      // this.centerDialogVisiblealternate = false;
      // this.centerDialogVisibleprimary = false;
      // this.centerDialogVisiblefavicon = false;
      this.$swal({
        title: "Success!",
        text: `File ${name} uploaded`,
        icon: "success",
        timer: 2000,
        buttons: false,
      });
    },
    inputMenuName() {
      if (this.menuName == "") {
        this.isShowErrorMenuName = true;
      } else {
        this.isShowErrorMenuName = false;
      }
    },
    beforeUpload(file) {
      let formData = new FormData();
      const fileType = file.type;
      formData.append("file", file);
      if (
        fileType.startsWith("image/jpeg") ||
        fileType.startsWith("image/png") ||
        fileType.startsWith("image/gif")
      ) {
        formData.append("type", "image");
      } else if (
        fileType.startsWith("video/mp4") ||
        fileType.startsWith("video/webm") ||
        fileType.startsWith("video/ogg")
      ) {
        formData.append("type", "video");
      } else if (fileType.startsWith("image/svg+xml")) {
        formData.append("type", "svg");
      } else {
        this.isShowDetailsAddons = false;
        this.$swal({
          title: "Error",
          text: `${file.type} not allowed`,
          icon: "error",
          timer: 5000,
          buttons: false,
        });
        return;
      }
      let URL = process.env.VUE_APP_BASE_URL_CORE_API.split("/api/")[0];
      formData.append("Storeendpoint", URL);
      this.uploadFile(formData, file.name);
      return false;
    },
    async uploadFile(formData, name) {
      await axios.post(
        process.env.VUE_APP_SVG_DATAENTRY + "/Media" + "/Save",
        formData,
        {
          headers: {
            "community-name": process.env.VUE_APP_COMMUNITY_NAME,
          },
        }
      );
      let mediaData = await axios.post(
        process.env.VUE_APP_SVG_DATAENTRY + "/Media" + "/Fetch",
        {},
        {
          headers: {
            "community-name": process.env.VUE_APP_COMMUNITY_NAME,
          },
        }
      );
      this.Fetchedmedias = mediaData.data;
      this.handleUploadSuccess(name);
    },
    primaryclick(item) {
      this.PrimaryLogoMedia = item;
      this.uploadImage = this.PrimaryLogoMedia.link;
      if (this.PrimaryLogoMedia != {}) {
        this.primarySrc = this.url1 + this.PrimaryLogoMedia.link;
        this.primaryLogo = this.PrimaryLogoMedia.link;
        this.uploaderPopup = false;
      }
    },
    ConfirmDelete() {
      return Swal.fire({
        title: `Are you sure you want to delete this?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#335080",
        cancelButtonColor: "  #6e7881",
        confirmButtonText: "Yes",
      });
    },
    VerifiedConfirmDelete() {
      return Swal.fire({
        title: `This menu is associated with sime other menu item. Are you sure you want to delete it?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#335080",
        cancelButtonColor: "  #6e7881",
        confirmButtonText: "Yes",
      });
    },
    async handledelete(item) {
      let res;
      if (item.ParentMenu.length > 0 || item.subMenu.length > 0) {
        res = await this.VerifiedConfirmDelete();
      } else {
        res = await this.ConfirmDelete();
      }
      if (res.isConfirmed) {
        const payload = {
          id: item._id,
        };
        try {
          let result = await this.$store.dispatch(
            "menu/deleteOneMenu",
            payload
          );
          if (result.code == 200) {
            this.getMenu();
            this.$swal({
              text: "Deleted Successfully",
              icon: "success",

              confirmButtonColor: "#830c81",
              // cancelButtonColor: "#d33",
              confirmButtonText: "Okay",
            });
          }
        } catch (err) {}
      }
    },

    async getPositionFunc(value) {
      let payload = {
        position: value,
        menutype: "Main-Menu",
      };
      let data = await this.$store.dispatch("twoHerMenu/getAllMenu", payload);
      if (data.data.length) {
        // this.$swal.fire({
        //   title: "Alert",
        //   text: "Position already exist!",
        //   icon: "warning",
        //   confirmButtonText: "OK",
        // });
        this.isShowPositionMsg = true;
      } else {
        this.isShowPositionMsg = false;
      }
    },
    async UpdateMainMenu() {
      await this.addPages();
      let responeValidate = this.validateMenu;
      if (responeValidate == true) {
        let payload = {
          menutype: this.selectedMenuType,
          _id: this.menuid,
        };
        if (this.position) {
          Object.assign(payload, { position: this.position });
        }
        if (this.menuName) {
          Object.assign(payload, { menuName: this.menuName });
        }
        if (this.uploadImage) {
          Object.assign(payload, { picture: this.uploadImage });
        }
        if (this.pageData.length > 0) {
          {
            Object.assign(payload, { pageData: this.pageData });
          }
        }
        if (this.menuParent.length > 0) {
          Object.assign(payload, { menu: this.menuParent });
        }
        if (this.selectedProduct) {
          Object.assign(payload, { menuData: this.selectedProduct });
        }
        if (this.selectedComponent) {
          Object.assign(payload, { menuData: this.selectedComponent });
        }
        if (this.menuURL) {
          Object.assign(payload, { menuData: this.menuURL });
        }
        if (this.selectedCategory) {
          Object.assign(payload, { menuData: this.selectedCategory });
        }
        console.log(payload, "pogjjlnkb");
        await this.$store.dispatch("menu/editMenu", payload);
        this.getMenu();
        this.isShowAddMainMenu = false;
        await this.handleclose();
      }
      if (responeValidate == false) {
        if (this.selectedMenuType == "") {
          this.isShowErrorMenuType = true;
        }
        if (this.menuName == "") {
          this.isShowErrorMenuName = true;
        }
        if (this.selectedMenuType == "page" && this.pageData == "") {
          this.isShowErrorMenuPage = true;
        }
        if (
          this.selectedMenuType == "element" &&
          this.selectedComponent == ""
        ) {
          this.isShowErrorComponent = true;
        }
        if (this.selectedMenuType == "product" && this.selectedProduct == "") {
          this.isShowErrorProduct == true;
        }
        if (
          this.selectedMenuType == "category" &&
          this.selectedCategory == ""
        ) {
          this.isShowErrorCategory == true;
        }
        if (this.selectedMenuType == "url" && this.menuURL == "") {
          this.isShowErrorUrl == true;
        }
      }
    },
    async updateSubMenu() {
      // const payload = new FormData();
      // payload.append("menuName", this.menuName);
      // payload.append("type", "Sub-Menu");
      // payload.append("_id", this.menuid);
      // for (let i in this.datavalue) {
      //   payload.append("menuImages", this.datavalue[i]);
      // }
      // if (this.pageData.length > 0) {
      //   if (this.pageData.length >= 2) {
      //     for (let i in this.pageData) {
      //       payload.append("pageData", JSON.stringify(this.pageData[i]));
      //     }
      //   } else {
      //     payload.append("pageData[0]", JSON.stringify(this.pageData));
      //   }
      // }
      let payload = {
        type: "Sub-Menu",
        _id: this.menuid,
      };
      if (this.menuName) {
        Object.assign(payload, { menuName: this.menuName });
      }
      if (this.uploadImage) {
        Object.assign(payload, { picture: this.uploadImage });
      }
      if (this.pageData.length > 0) {
        // if (this.pageData.length >= 2) {
        //   for (let i in this.pageData) {
        //     Object.assign(payload, {
        //       pageData: this.pageData[i],

        //     });
        //   }
        // } else {
        Object.assign(payload, { pageData: this.pageData });
        // }
      }
      await this.$store.dispatch("twoHerMenu/editMenu", payload);
      await this.getMenu();
      this.isShowAddMenu = false;
      await this.handleclosesubmenu();
    },
    handleclosesubmenu() {
      this.updatesubment = false;
      this.updatemenu = false;
      this.isShowAddMenu = false;
      this.submenuimage = "";
      this.menuName = "";
      this.selectedComponent = "";
      this.selectedMenuType = "";
      this.renderedmultipleImage.splice(0);
      this.datavalue.splice(0);
      this.PrimaryLogoMedia = {};
      this.uploadImage = "";
      this.mainmenuimage = "";
      this.menuid = [];
      this.position = "";
      this.page = [];
      this.selectedCategory = "";
      this.selectedProduct = "";
      this.menuURL = "";
      this.selectedMenu = [];
      this.ispage = false;
      this.isProduct = false;
      this.isCategory = false;
      this.isURL = false;
      this.isElement = false;
    },
    handleclose() {
      this.updatemenu = false;
      this.updatesubment = false;
      this.submenuimage = "";
      this.mainmenuimage = "";
      this.renderedmultipleImage.splice(0);
      this.datavalue.splice(0);
      this.menuName = "";
      this.selectedComponent = "";
      this.selectedMenuType = "";
      this.PrimaryLogoMedia = {};
      this.uploadImage = "";
      this.menuid = "";
      this.menu = [];
      this.position = "";

      this.isShowAddMainMenu = false;
    },
    handleEdit(item) {
      this.selectedItem = item;
      this.menuid = item._id;
      this.isShowAddMainMenu = true;

      this.mainmenuimage = item.menuImage[0];
      this.uploadImage = item.menuImage[0];
      this.menuName = item.menuName;
      this.position = item.position;
      this.selectedMenuType = item.menutype;
      this.page = [];
      this.menuParent = [];
      this.menu = [];
      for (let i = 0; i <= item.subMenu.length - 1; i++) {
        this.menu.push(item.subMenu[i].menuName);
      }

      for (let i = 0; i <= item.ParentMenu.length - 1; i++) {
        this.menuParent.push(item.ParentMenu[i]._id);
      }
      for (let i = 0; i < item.pageData.length; i++) {
        this.page.push(item.pageData[i].page);
      }
      if (item.menutype == "page") {
        this.ispageEdit = true;
        this.isProductEdit = false;
        this.isCategoryEdit = false;
        this.isURLEdit = false;
        this.isElementEdit = false;
      }
      if (item.menutype == "product") {
        this.ispageEdit = false;
        this.isProductEdit = true;
        this.isCategoryEdit = false;
        this.isURLEdit = false;
        this.isElementEdit = false;
        this.selectedProduct = item.menuData;
      }

      if (item.menutype == "category") {
        this.ispageEdit = false;
        this.isProductEdit = false;
        this.isCategoryEdit = true;
        this.isURLEdit = false;
        this.isElementEdit = false;
        this.selectedCategory = item.menuData;
      }
      if (item.menutype == "url") {
        this.ispageEdit = false;
        this.isProductEdit = false;
        this.isCategoryEdit = false;
        this.isURLEdit = true;
        this.isElementEdit = false;
        this.menuURL = item.menuData;
      }
      if (item.menutype == "element") {
        this.ispageEdit = false;
        this.isProductEdit = false;
        this.isCategoryEdit = false;
        this.isURLEdit = false;
        this.isElementEdit = true;
      }
      this.updatemenu = true;
      this.isShowAddMainMenu = true;
    },

    async getTasklist() {
      const { data } = await this.$store.dispatch("builder/getTasklist", {
        // projectName: "testApplication1",
        projectName: process.env.VUE_APP_COMMUNITY_NAME,
      });
      this.tasklist = data;
    },

    async getPages() {
      const { data } = await this.$store.dispatch("builder/getPages", {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
        // tasklistID: this.tasklist[this.tasklist.length - 1]._id,
        getDistinctData: true,
      });
      //       64143e47b3abba001229771d
      // 64a651a04c39a800126d5471
      this.pages = data;
    },

    async getMenu() {
      let offset = 0;
      let payload = {
        pagination: true,
      };
      // this.$store.dispatch("twoHerMenu/getAllMenu");
      if (this.currentPage == 1) {
        Object.assign(payload, { offset: offset });
      } else {
        offset = 10 * this.currentPage - 10;
        Object.assign(payload, { offset: offset });
      }
      let data = await this.$store.dispatch("menu/getAllMenu", payload);
      this.submenuData = data.data.filter((x) => x.menutype == "Sub-Menu");
      this.pageCount = data.data.count;
    },
    openAddMenuForm() {
      this.isShowAddMenu = true;
      this.getMenu();
    },
    openAddMainMenuForm() {
      this.isShowAddMainMenu = true;
      this.getMenu();
    },
    showImage(value) {
      let default_image = require("@/assets/images/card1.png");
      let image_base_url = this.$imageURL;
      return value ? `${image_base_url}/${value}` : default_image;
    },
    async multipleimages(file) {
      if (file.type.startsWith("image/")) {
        if (this.datavalue.length < 1) {
          this.datavalue.push(file);
        } else {
          this.datavalue.shift(file);
        }
        this.newHandlemultiple(file);
      } else {
        this.$message.error(" File not supported");
      }
    },

    async newHandlemultiple(rawFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (this.renderedmultipleImage.length < 1) {
          this.$emit("load", this.renderedmultipleImage.push(e.target.result));
        } else {
          this.$emit("load", this.renderedmultipleImage.shift(e.target.result));
        }
      };

      reader.readAsDataURL(rawFile);
    },

    async addMenu() {
      // const payload = new FormData();
      // payload.append("menuName", this.menuName);
      // payload.append("type", "Sub-Menu");
      // for (let i in this.datavalue) {
      //   payload.append("menuImages", this.datavalue[i]);
      // }
      // if (this.pageData.length > 0) {
      //   if (this.pageData.length >= 2) {
      //     for (let i in this.pageData) {
      //       // payload.append("pageData", this.pageData[i]);
      //       payload.append("pageData", JSON.stringify(this.pageData[i]));
      //     }
      //   } else {
      //     payload.append("pageData[0]", JSON.stringify(this.pageData));
      //   }
      // }
      let responeValidate = (await this.validateMenu) && this.validateMenuType;
      console.log(this.validateMenu, "uybub");
      console.log(this.validateMenuType, "jjhb");
      if (this.validateMenu == true && this.validateMenuType == true) {
        let payload = {
          menutype: this.selectedMenuType,
          position: this.position,
        };
        if (this.menuName) {
          Object.assign(payload, { menuName: this.menuName });
        }
        if (this.uploadImage) {
          Object.assign(payload, { picture: this.uploadImage });
        }
        if (this.pageData.length > 0) {
          {
            Object.assign(payload, { pageData: this.pageData });
          }
        }
        if (this.selectedProduct) {
          Object.assign(payload, { menuData: this.selectedProduct });
        }
        if (this.selectedComponent) {
          Object.assign(payload, { menuData: this.selectedComponent });
        }
        if (this.menuURL) {
          Object.assign(payload, { menuData: this.menuURL });
        }
        if (this.selectedCategory) {
          Object.assign(payload, { menuData: this.selectedCategory });
        }
        if (this.selectedMenu.length > 0) {
          // if (this.selectedMenu.length >= 2) {
          // for (let i of this.selectedMenu) {
          Object.assign(payload, { menu: this.selectedMenu });
          // }
          // } else {
          //   Object.assign(payload, { menu: this.selectedMenu });
          // }
        }
        let result = await this.$store.dispatch("menu/addOneMenu", payload);
        this.isShowAddMenu = false;
        await this.handleclosesubmenu();
        await this.getMenu();
      } else {
        if (this.selectedMenuType == "") {
          this.isShowErrorMenuType = true;
        }
        if (this.menuName == "") {
          this.isShowErrorMenuName = true;
        }
        if (this.selectedMenuType == "page" && this.pageData == "") {
          this.isShowErrorMenuPage = true;
        }
        if (
          this.selectedMenuType == "element" &&
          this.selectedComponent == ""
        ) {
          this.isShowErrorComponent = true;
        }
        if (this.selectedMenuType == "product" && this.selectedProduct == "") {
          this.isShowErrorProduct == true;
        }
        if (
          this.selectedMenuType == "category" &&
          this.selectedCategory == ""
        ) {
          this.isShowErrorCategory == true;
        }
        if (this.selectedMenuType == "url" && this.menuURL == "") {
          this.isShowErrorUrl == true;
        }
      }
    },
    inputCategoryData() {
      if (this.selectedCategory == "") {
        this.isShowErrorCategory = true;
      } else {
        this.isShowErrorCategory = false;
      }
    },
    inputMenuURLData() {
      if (this.menuURL == "") {
        this.isShowErrorUrl = true;
      } else {
        this.isShowErrorUrl = false;
      }
    },
    inputProductData() {
      if (this.selectedProduct == "") {
        this.isShowErrorProduct = true;
      } else {
        this.isShowErrorProduct = false;
      }
    },
    async addPages() {
      this.pageData = [];
      if (this.page.length == 0) {
        this.isShowErrorMenuPage = true;
      } else {
        this.isShowErrorMenuPage = false;
      }
      for (let i of this.pages) {
        if (i.name == this.page) {
          this.pageData.push(i);
        }
      }
      console.log(this.pageData, "kuhiu");
      const { data } = await this.$store.dispatch(
        "builder/getPagesComponents",
        {
          pageName: this.page,
          projectName: this.selectedProject.projectName,
        }
      );
      if (this.page != "" && this.selectedMenuType == "element") {
        this.isElement = true;
      }
      if (data) {
        this.components = data;
      }
    },
    addSelectedMenu(data) {
      this.selectedMenu = [];
    },
  },
  computed: {
    ...mapState("twoHerMenu", ["combinedMenuData"]),
    ...mapState("user", ["selectedProject"]),
    ...mapState("EcomCategory", ["detailedCategory"]),
    ...mapState("EcomProduct", ["productDetails"]),
    ...mapState("menu", ["menuData"]),
    imageURL() {
      // return "https://nimbuscluster.blob.core.windows.net/server01/";
      return this.$imageURL;
    },
    validateMenu() {
      return (
        this.selectedMenuType != "" && this.menuName != ""
        // this.validateMenuType()
      );
    },
    validateMenuType() {
      if (this.selectedMenuType == "page") {
        return this.pageData != "";
      }
      if (this.selectedMenuType == "product") {
        return this.selectedProduct != "";
      }
      if (this.selectedMenuType == "category") {
        return this.selectedCategory != "";
      }
      if (this.selectedMenuType == "url") {
        return this.menuURL != "";
      }
      if (this.selectedMenuType == "element") {
        return this.selectedComponent != "";
      }
    },
  },

  async mounted() {
    await this.getTasklist();
    await this.getPages();
    await this.getMenu();
    await this.Fetchmedia();
    this.preloadData();
  },
  watch: {
    isShowAddMenu(value) {
      if (!value) {
        (this.menuName = ""),
          (this.menu = []),
          (this.page = []),
          (this.menuImage = "");
      }
    },
    async position(value) {
      if (value != "") {
        await this.getPositionFunc(value);
      } else {
        this.isShowPositionMsg = false;
      }
    },
    async uploadImage(value) {
      if (value == "") {
        this.PrimaryLogoMedia = {};
      }
    },
  },
};
</script>
<style scoped>
.imgpre {
  height: 270px;
  border-radius: 8px;
  width: 100%;
}
.topright181011 {
  top: 18px;
  right: 10px;
}
</style>
